const { REACT_APP_SAS_URL } = process.env;

export const retornarObterCep = async (sessionId, cep) => {
  const headers = { "Content-Type": "application/json" };

  const body = JSON.stringify({
    SessionID: sessionId,
    screenIdentification: "SASGC0068",
    Parameters: [
      {
        parametername: "CEP",
        parametervalue: cep,
      },
    ],
  });

  const requestOptions = {
    method: "POST",
    redirect: "follow",
    headers,
    body,
  };

  return await fetch(`${REACT_APP_SAS_URL}`, requestOptions)
    .then((response) => response.json())
    .then(async (result) => {
      return result.responseJSONData
        ? result.responseJSONData.find(() => true)
        : undefined;
    });
};
